import axios from "@/api/axiosInstance";
import type {
  FetchZipcodeMarketValuesRequest,
  FetchZipcodeMarketValuesResponse,
} from "./types";

export const fetchZipcodeMarketValues = async (
  zipcodes: string[],
): Promise<FetchZipcodeMarketValuesResponse> => {
  const requestData: FetchZipcodeMarketValuesRequest = { zipcodes };
  const response = await axios.post<FetchZipcodeMarketValuesResponse>(
    "/api/private/market-value/zipcodes",
    requestData,
  );
  return response.data;
};
